import { Provider } from 'react-redux';

import { createRoot } from 'react-dom/client';

import { RoutesApp } from './routes/routes';
import { store } from './store/index';

import './style/index.scss';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <RoutesApp />
  </Provider>
);
